import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
// core components

export default function CardCredit() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          background:
            "linear-gradient(87deg," +
            theme.palette.error.main +
            ",#f56036)!important",
        }}
      >
        <CardContent>
          <Grid
            container
            component={Box}
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Grid item xs="auto">
              <Box
                component="img"
                sx={{ verticalAlign: "center", borderStyle: "none" }}
                src={require("assets/img/icons/cards/bitcoin.png").default}
                alt="..."
              ></Box>
            </Grid>
            <Grid item xs="auto">
              <Badge
                badgeContent={"success"}
                color="success"
                variant="relative-lg"
              ></Badge>
            </Grid>
          </Grid>
          <Box sx={{ marginBottom: "1.5rem", marginTop: "1.5rem" }}>
            <Typography
              variant="h6"
              component="span"
              sx={{
                color: theme.palette.gray[400],
                marginBottom: 0,
                letterSpacing: "2px",
                textTransform: "uppercase",
              }}
            >
              Username
            </Typography>
            <Typography
              variant="h1"
              component="div"
              sx={{ color: theme.palette.white.main }}
            >
              @johnsnow
            </Typography>
          </Box>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                component="span"
                sx={{
                  color: theme.palette.gray[400],
                  marginBottom: 0,
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                }}
              >
                Name
              </Typography>
              <Typography
                variant="h3"
                component="span"
                sx={{ color: theme.palette.white.main, display: "block" }}
              >
                John Snow
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
